import {useChartStyles} from '@hconnect/common-chartjs-config'
import {Moment} from 'moment-timezone'
import React from 'react'

import {ChartLine} from './ChartLine'
import {LinearScaleFn, TimeScaleFn} from './utils/scale'

interface ChartNowLineProps {
  xScale: TimeScaleFn
  // if yScale is not defined, then minY and maxY means y coordinates
  // if yScale is defined, then minY and maxY are values and coordinated are calculated via yScale(VALUE)
  yScale?: LinearScaleFn
  currentTime: Moment
  maxY: number
  minY: number
  testId?: string
}

export const ChartNowLine: React.FC<ChartNowLineProps> = ({
  xScale,
  yScale,
  currentTime,
  maxY,
  minY,
  testId = 'now_line'
}) => {
  const {nowLineColor} = useChartStyles()

  return (
    <ChartLine
      variant="vertical"
      xScale={xScale}
      yScale={yScale}
      yDomain={[minY, maxY]}
      xValue={currentTime}
      testId={testId}
      overrideLineAttributes={{stroke: nowLineColor}}
    />
  )
}
